export const PAYMENT_FIELD_NAMES = {
  cardNumber: "cardNumber",
  expDate: "exp-date",
  cvv2: "cvv2",
  nameoncard: "nameoncard"
}